<template>
  <section class="statv_wrapper">
    <div class="date_list">
      <div 
        class="date_item"
        v-for="(day, idx) in days" 
        :key="`day_${idx}`"
        @click.prevent=""> 
        <span> {{day.shortDate}} </span>
        <span> {{day.korDate}} </span>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import * as Store from "@/store/modules/schedule"                                            

export default {
  data() {
    return {
      days: []
    }
  },
  created() {
    this.getDate(0)
  },
  computed: {
    ...Store.mapState([
      'schedules'
    ]),
  },
  methods: {
    ...Store.mapActions([
      'getScheduleRange'
    ]),
    onSearch() {
      
    },
    getDate(cnt) {

    }
  }
}
</script>
<style lang="less">
.date_list {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  .date_item {
    text-align: center;
    flex: 1 0 0;
    cursor: pointer;
    &:hover {
      font-weight: bold;
    }
    font-size: 25px;
  }
}
</style>